import React, {useCallback} from 'react';
import {toast as sonnerToast, Toaster} from 'sonner';
import {debugLog} from '../lib/debug';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export const useToast = () => {
  const showToast = useCallback((message: string, type: ToastType = 'info', duration = 3000) => {
    debugLog('[Toast] showToast called:', {message, type, duration});
    const baseAction = {
      label: '✕',
      onClick: () => {},
    };

    switch (type) {
      case 'success':
        debugLog('[Toast] Showing success toast');
        sonnerToast.success(message, {
          duration,
          action: {
            ...baseAction,
          },
          style: {
            background: '#16a34a',
            color: '#fff',
            border: '1px solid #15803d',
          },
          actionButtonStyle: {
            background: '#15803d',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            padding: '4px 8px',
          },
        });
        break;
      case 'error':
        debugLog('[Toast] Showing error toast');
        sonnerToast.error(message, {
          duration,
          action: {
            ...baseAction,
          },
          style: {
            background: '#dc2626',
            color: '#fff',
            border: '1px solid #b91c1c',
          },
          actionButtonStyle: {
            background: '#b91c1c',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            padding: '4px 8px',
          },
        });
        break;
      case 'warning':
        debugLog('[Toast] Showing warning toast');
        sonnerToast.warning(message, {
          duration,
          action: baseAction,
          actionButtonStyle: {
            border: 'none',
            borderRadius: '4px',
            padding: '4px 8px',
          },
        });
        break;
      case 'info':
      default:
        debugLog('[Toast] Showing info toast');
        sonnerToast.info(message, {
          duration,
          action: baseAction,
          actionButtonStyle: {
            border: 'none',
            borderRadius: '4px',
            padding: '4px 8px',
          },
        });
        break;
    }
  }, []);

  return {showToast};
};

export const ToastContainer: React.FC = () => {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        style: {
          background: '#1f2937',
          color: '#fff',
          border: '1px solid #374151',
        },
        className: 'sonner-toast',
      }}
    />
  );
};

// Legacy export for backward compatibility
export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({children}) => {
  return <>{children}</>;
};